/**
 * Product recommendations
 *
 * @module product-recommendations
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "product-recommendations";

if (!customElements.get(customElements.component)) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "product-recommendations"
            );

            if (
              recommendations &&
              recommendations.innerHTML.trim().length > 0
            ) {
              this.innerHTML = recommendations.innerHTML;

              // Initialize swiper slider after content is loaded
              setTimeout(() => {
                const swiperSlider = this.querySelector("swiper-slider");
                if (
                  swiperSlider &&
                  typeof swiperSlider.initSlider === "function"
                ) {
                  swiperSlider.initSlider();
                }
              }, 100);
            }
          })
          .catch(() => {
            // Error loading recommendations
          });
      };

      this._intersectionObserver = new IntersectionObserver(
        handleIntersection.bind(this),
        {
          rootMargin: "0px 0px 200px 0px",
        }
      );
      this._intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      // Clean up the IntersectionObserver when element is removed
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
    }

    reloadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            this.innerHTML = recommendations.innerHTML;
          }

          // Reinitialize swiper slider after reload
          setTimeout(() => {
            const swiperSlider = this.querySelector("swiper-slider");
            if (
              swiperSlider &&
              typeof swiperSlider.reinitSlider === "function"
            ) {
              swiperSlider.reinitSlider();
            }
          }, 100);
        })
        .catch(() => {
          // Error reloading recommendations
        });
    }

    updateUrlAndReload(newUrl) {
      this.dataset.url = newUrl;
      this.reloadRecommendations();
    }
  }

  customElements.define(customElements.component, ProductRecommendations);
}
